interface UterusOrganIconProps {
  className?: string
  size?: number
}

export function UterusOrganIcon({
  className,
  size = 32,
}: UterusOrganIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
      className={className}
    >
      <path
        fill="currentColor"
        d="m17.516 13.284 2.726-4.715-.855-.483L16.66 12.8a.19.19 0 0 1-.166.095.19.19 0 0 1-.165-.095l-2.72-4.715-.856.483 2.72 4.715c.211.367.593.587 1.02.587h.001c.428 0 .81-.22 1.021-.586"
      />
      <path
        fill="currentColor"
        d="M28.252 6.634a5.57 5.57 0 0 0-2.99-2.45c-2.392-.83-4.378.189-6.3 1.173-.372.19-.757.388-1.136.567-.87.41-1.78.41-2.653 0-.354-.167-.72-.352-1.072-.53-1.967-.998-4.001-2.03-6.363-1.21a5.57 5.57 0 0 0-2.99 2.451 5.46 5.46 0 0 0-.736 3.128c.06.882.333 1.738.794 2.492a1.956 1.956 0 0 0 .423 2.18 2 2 0 0 0 1.416.581c.534 0 1.037-.206 1.415-.58a1.96 1.96 0 0 0 0-2.799 2 2 0 0 0-1.415-.58v.974a1.014 1.014 0 0 1 1.016 1.005 1.014 1.014 0 0 1-1.016 1.005 1.013 1.013 0 0 1-1.016-1.005c0-.193.056-.38.161-.543l.176-.271-.183-.266a4.54 4.54 0 0 1-.788-2.26c-.06-.901.15-1.792.607-2.576a4.6 4.6 0 0 1 2.462-2.017c1.963-.682 3.723.21 5.587 1.156.36.183.731.371 1.099.544a4.01 4.01 0 0 0 3.5 0c.393-.186.786-.387 1.166-.581 1.816-.931 3.53-1.81 5.52-1.12a4.58 4.58 0 0 1 2.462 2.019c.458.784.668 1.674.607 2.575a4.5 4.5 0 0 1-.787 2.26l-.183.266.175.271a.99.99 0 0 1-.136 1.254l-.053.053a1.02 1.02 0 0 1-.662.243 1.014 1.014 0 0 1-1.016-1.005c0-.26.1-.506.283-.694l.022-.023c.19-.186.443-.288.71-.288v-.975a2 2 0 0 0-1.414.58l-.034.035c-.357.37-.553.836-.553 1.365s.208 1.025.586 1.4a2 2 0 0 0 1.415.58v-.002a2 2 0 0 0 1.416-.58l.593-.59-.165-.046a1.955 1.955 0 0 0-.009-1.545c.462-.754.735-1.61.794-2.493a5.45 5.45 0 0 0-.735-3.128"
      />
      <path
        fill="currentColor"
        d="m8.924 8.087-.858.48 6.67 11.635.023.028c.072.091.111.205.111.32v7.57h.986v-7.569c0-.319-.106-.633-.297-.89zM24.076 8.087 17.441 19.66c-.192.256-.297.57-.297.89v7.57h.985v-7.57c0-.116.04-.23.112-.32l.023-.029 6.67-11.634z"
      />
    </svg>
  )
}
